module.exports = {"id":"188334","name":"Fabrizio Cacciatore","rating":"74","photo":"./data/images/photos/3/188334.png","club":{"name":"Chievo Vérone","logo":"./data/images/clubs/ChievoVerone.png"},"positions":["DD","DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabrizioCacciatore0.json
// module id = 1356
// module chunks = 0